import { NgStyle } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { IconComponent } from '@examdojo/core/icon';
import { IonSpinner } from '@ionic/angular/standalone';
import { IndicatorStatus } from './save-indicator.model';

@Component({
  selector: 'dojo-save-indicator',
  templateUrl: './save-indicator.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent, IonSpinner, NgStyle],
  host: {
    class: 'flex items-center gap-1',
  },
})
export class SaveIndicatorComponent {
  readonly status = input<IndicatorStatus>();
  readonly size = input<number>(20);
  readonly IndicatorStatus = IndicatorStatus;
}
